import React, { useState, useEffect } from "react";
import api from "../../services/api";

export default function RecentJobs() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
const response = await api.get('/public-jobs');
      setJobs(response.data);
    } catch (error) {
      console.error("Error fetching recent jobs:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm p-6">
      <div className="flex justify-between items-center mb-5">
        <h2 className="text-xl font-bold text-gray-900">Recent Jobs</h2>
      </div>

      {/* FIX: Yahan max height (approx 5 records) aur overflow-y-auto laga diya hai */}
      <div className="overflow-x-auto overflow-y-auto max-h-[360px] rounded-lg border border-gray-100">
        <table className="w-full text-left text-sm relative">
          {/* FIX: Header ko sticky kar diya taaki scroll karne par vo upar hi rahe */}
          <thead className="bg-gray-50 text-gray-500 sticky top-0 z-10 shadow-sm">
            <tr>
              <th className="px-4 py-3 font-medium">Job Title</th>
              <th className="px-4 py-3 font-medium">Company</th>
              <th className="px-4 py-3 font-medium">Location</th>
              <th className="px-4 py-3 font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                  Loading jobs...
                </td>
              </tr>
            ) : jobs && jobs.length > 0 ? (
              jobs.map((job, index) => (
                <tr key={job.id || index} className="border-b last:border-0 hover:bg-gray-50/50 transition-colors">
                  <td className="px-4 py-4 font-semibold text-gray-900">
                    {job.title || job.job_title || "Untitled Job"}
                  </td>
                  <td className="px-4 py-4 text-gray-600">
                    {job.company || "N/A"}
                  </td>
                  <td className="px-4 py-4 text-gray-600">
                    {job.location || "N/A"}
                  </td>
                  <td className="px-4 py-4">
                    <span className={`px-2 py-1 rounded-md text-xs font-medium ${
                      (job.status && job.status.toLowerCase() === 'active') || !job.status
                        ? 'bg-green-50 text-green-600' 
                        : 'bg-red-50 text-red-600'
                    }`}>
                      {job.status || "Active"}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="px-4 py-8 text-center text-gray-500">
                  No recent jobs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}